import { KullanicieklePage } from './../kullaniciekle/kullaniciekle';

import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController } from 'ionic-angular';
import { BllOrtak } from '../../../providers/bll/bll-ortak';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the KullaniciListePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-kullanici-liste',
  templateUrl: 'kullanici-liste.html',
})
export class KullaniciListePage {
  KullaniciListesi=[];
  aranan="";
  skip:number=0;
  take:number=50;

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public modalCtrl:ModalController,
    public ortak:Ortak,
    public act:ActionSheetController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.kayitAra(null);
  }
  kayitAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "KullaniciListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.KullaniciListesi = sonuc.SonucObject;
     
   
 
    })
  }
  
  kullanicikayitlari(e) {

    if (e.keyCode == 13) {
      this.kayitAra(e);
    }
  }
  yenikayit() {
    let modal = this.modalCtrl.create(KullanicieklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  Kullaniciduzenle(user){
    let modal = this.modalCtrl.create(KullanicieklePage, { UserVw: user });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  
  }
  KullaniciSil(user) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("ID", user.ID);
 
      this.bllOrtak.islem(formData, "UserDelete", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.kayitAra("");
     
    })
   
  }
  Islemler(user) {
    const actionSheet = this.act.create({
      title: user.Name,
      buttons: [
        {
          text: 'Sil',

          handler: () => {
            this.KullaniciSil(user);
          }

        },
        {
          text: 'Düzenle',
          handler: () => {
            this.Kullaniciduzenle(user);
          }
        }, {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
        
          }
        }
      ]
    });
    actionSheet.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/kullanici-liste/kullanici-liste.ts